// TeaRitual port: tea picker + per-tea guided timer (useRitualTimer,
// RitualStepView, RitualControls, TeaBowl). Remaining time is derived from
// wall-clock timestamps — background tabs throttle intervals.
(() => {
  const root = document.querySelector('[data-mizu-tea]');
  if (!root) return;
  const animate = () => (document.documentElement.dataset.motion || 'static') !== 'static';
  const EMPTY_Y = 148;
  const FULL_Y = 74;
  const fmt = (s) => {
    const total = Math.max(0, Math.ceil(s));
    return `${String(Math.floor(total / 60)).padStart(2, '0')}:${String(total % 60).padStart(2, '0')}`;
  };

  function createTimer(box) {
    const steps = JSON.parse(box.dataset.steps);
    const labels = [...box.querySelector('[data-tea-labels]').content.children].map((n) => n.textContent);
    const stepOf = box.querySelector('[data-tea-stepof-tpl]').innerHTML;
    const $ = (sel) => box.querySelector(sel);
    let index = 0;
    let startedAt = null;
    let tick = null;

    const done = () => index >= steps.length;
    const seconds = () => (done() ? 0 : steps[index]);
    const remaining = () => (startedAt === null ? seconds() : Math.max(0, seconds() - (Date.now() - startedAt) / 1000));

    function bowl(progress) {
      const liquid = $('[data-tea-liquid]');
      const y = EMPTY_Y - (EMPTY_Y - FULL_Y) * Math.min(Math.max(progress, 0), 1);
      liquid.style.transform = `translateY(${y}px)`;
      ['transition-transform', 'duration-[800ms]', 'ease-out'].forEach((c) => liquid.classList.toggle(c, animate()));
      box.querySelectorAll('[data-wave]').forEach((p) => p.classList.toggle(p.dataset.wave, animate()));
      $('[data-tea-steam]').hidden = !(animate() && progress > 0.05);
    }

    function render() {
      const timed = seconds() > 0;
      const running = startedAt !== null;
      $('[data-tea-active]').hidden = done();
      $('[data-tea-done]').hidden = !done();
      if (!done()) {
        $('[data-tea-stepof]').textContent = stepOf.replace('__N__', index + 1).replace('__T__', steps.length);
        $('[data-tea-label]').textContent = labels[index];
      }
      $('[data-tea-clock]').hidden = !timed;
      $('[data-tea-clock]').textContent = fmt(remaining());
      $('[data-tea-start]').hidden = done() || !timed || running;
      $('[data-tea-next]').hidden = done() || timed;
      $('[data-tea-reset]').hidden = !(index > 0 || done());
      const progress = running && timed ? 1 - remaining() / seconds() : 0;
      bowl((index + (timed ? progress : 0)) / steps.length);
    }

    function stop() { clearInterval(tick); tick = null; startedAt = null; }
    function advance() { stop(); index = Math.min(index + 1, steps.length); render(); }
    function start() {
      startedAt = Date.now();
      tick = setInterval(() => {
        if (remaining() > 0) return render();
        navigator.vibrate?.(200);
        advance();
      }, 200);
      render();
    }
    function reset() { stop(); index = 0; render(); }

    $('[data-tea-start]').addEventListener('click', start);
    $('[data-tea-next]').addEventListener('click', advance);
    $('[data-tea-reset]').addEventListener('click', reset);
    render();
    return { reset };
  }

  const timers = new Map();
  root.querySelectorAll('[data-tea-panel]').forEach((panel) =>
    timers.set(panel.dataset.teaPanel, createTimer(panel.querySelector('[data-tea-timer]'))));

  const ON = ['border-ink', 'bg-ink', 'text-paper'];
  const OFF = ['border-mist', 'text-stone', 'hover:border-stone'];
  root.querySelectorAll('[data-tea-pick]').forEach((btn) => btn.addEventListener('click', () => {
    const id = btn.dataset.teaPick;
    root.querySelectorAll('[data-tea-pick]').forEach((b) => {
      const on = b === btn;
      b.setAttribute('aria-pressed', String(on));
      ON.forEach((c) => b.classList.toggle(c, on));
      OFF.forEach((c) => b.classList.toggle(c, !on));
    });
    root.querySelectorAll('[data-tea-panel]').forEach((p) => { p.hidden = p.dataset.teaPanel !== id; });
    timers.get(id)?.reset();
    root.querySelector('[data-tea-cta]').href = btn.dataset.cta;
  }));
})();
